import React from "react";
import { useTranslation } from "react-i18next";

export const SupportSection: React.FC = () => {
  const { t } = useTranslation();

  const mailtoLink = `mailto:info@chatharmony.ai`;

  return (
    <a
      href={mailtoLink}
      className="rounded-[10px] border border-border-secondary dark:border-gray-600 bg-bg-primary dark:bg-gray-800 p-4 flex flex-col gap-3"
    >
      <p className="text-sm font-semibold text-text-secondary dark:text-gray-200">
        {t("settings.usage.supportMessage")}
      </p>

      <button className="w-fit px-3.5 py-2.5 border border-border-secondary dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg text-sm font-semibold text-text-secondary dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors">
        {t("settings.usage.contactUs")}
      </button>
    </a>
  );
};
